import { DadosChamadaType } from "../types";

export function mapperDadosChamada(data: string): DadosChamadaType {
  const dadosObj = data
    .trim()
    .split(";")
    .reduce(
      (a, c, i) => ({
        ...a,
        [[
          "servidor",
          "branco",
          "telefone",
          "contrato",
          "idGrupo",
          "branco",
          "grupo",
          "usuario",
          "descricao",
          "mailing1",
          "mailing2",
          "tipoChamada",
          "idChamada",
        ][i]]: c,
      }),
      {}
    );

  return dadosObj as DadosChamadaType;
}
